import { render, staticRenderFns } from "./SearchResults.vue?vue&type=template&id=f0a9d6fe&scoped=true"
import script from "./SearchResults.vue?vue&type=script&lang=ts"
export * from "./SearchResults.vue?vue&type=script&lang=ts"
import style0 from "./SearchResults.vue?vue&type=style&index=0&id=f0a9d6fe&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a9d6fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src400484917/src/search.myaileron.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0a9d6fe')) {
      api.createRecord('f0a9d6fe', component.options)
    } else {
      api.reload('f0a9d6fe', component.options)
    }
    module.hot.accept("./SearchResults.vue?vue&type=template&id=f0a9d6fe&scoped=true", function () {
      api.rerender('f0a9d6fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/search/SearchResults.vue"
export default component.exports